export default "__VITE_ASSET__Zwp$Zw4X__"